module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XIV"
    }
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "map_p1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "600",
      "src": "images/Ixiv-1.jpg",
      "width": "550"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "series",
    attrs: {
      "id": "map_p2"
    }
  }, [_vm._v("SKETCH MAP OF LAN-FANG")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p3"
    }
  }, [_vm._v("1. "), _c('i', [_vm._v("Tribunal")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p4"
    }
  }, [_vm._v("2. "), _c('i', [_vm._v("Temple of the City God")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p5"
    }
  }, [_vm._v("3. "), _c('i', [_vm._v("Temple of Confucius")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p6"
    }
  }, [_vm._v("4. "), _c('i', [_vm._v("Temple of the War God")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p7"
    }
  }, [_vm._v("5. "), _c('i', [_vm._v("Bell Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p8"
    }
  }, [_vm._v("6. "), _c('i', [_vm._v("Drum Tower")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p9"
    }
  }, [_vm._v("7. "), _c('i', [_vm._v("Pagoda")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p10"
    }
  }, [_vm._v("8. "), _c('i', [_vm._v("Northern Row")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p11"
    }
  }, [_vm._v("9. "), _c('i', [_vm._v("Southern Row")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p12"
    }
  }, [_vm._v("10. "), _c('i', [_vm._v("Chien Mow’s Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p13"
    }
  }, [_vm._v("11. "), _c('i', [_vm._v("General Ding’s Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p14"
    }
  }, [_vm._v("12. "), _c('i', [_vm._v("Eternal Spring Wineshop")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p15"
    }
  }, [_vm._v("13. "), _c('i', [_vm._v("Hermitage of the Three Treasures")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p16"
    }
  }, [_vm._v("14. "), _c('i', [_vm._v("Mrs. Lee’s House")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p17"
    }
  }, [_vm._v("15. "), _c('i', [_vm._v("Former Yoo Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p18"
    }
  }, [_vm._v("16. "), _c('i', [_vm._v("Yoo Kee’s Mansion")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p19"
    }
  }, [_vm._v("17. "), _c('i', [_vm._v("Watergate")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "map_p20"
    }
  }, [_vm._v("18. "), _c('i', [_vm._v("Execution Ground")])])])]), _c('a', {
    attrs: {
      "id": "page_XIV"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbea1574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map.vue
// module id = 78
// module chunks = 0